import { useRef, useCallback } from 'react';
import apiClient from '../api/client';

interface CacheEntry {
  url: string;
  fetchedAt: number;
}

const TTL_MS = 45 * 60 * 1000; // 45 minutes

export function usePresignedUrlCache(basePath: string) {
  const cache = useRef(new Map<string, CacheEntry>());

  const getUrl = useCallback(
    async (s3Key: string): Promise<string> => {
      const entry = cache.current.get(s3Key);
      if (entry && Date.now() - entry.fetchedAt < TTL_MS) {
        return entry.url;
      }

      const res = await apiClient.get(`${basePath}/artifacts/url`, {
        params: { s3_key: s3Key },
      });
      const url = res.data.url;
      cache.current.set(s3Key, { url, fetchedAt: Date.now() });
      return url;
    },
    [basePath]
  );

  return getUrl;
}
